export const downloadFileFromUrl = async (
  url: string,
  customFileName?: string,
): Promise<void> => {
  try {
    // 1. Faz o fetch do arquivo
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Erro ao buscar arquivo: ${response.statusText}`);
    }

    // 2. Transforma a resposta em um Blob
    const blob = await response.blob();

    // 3. Define o nome do arquivo (do argumento ou extraído da própria URL)
    const fileName =
      customFileName || url.split('/').pop()?.split('?')[0] || 'download';

    // 4. Cria uma URL temporária do objeto em memória
    const blobUrl = window.URL.createObjectURL(blob);

    // 5. Cria um elemento <a> fantasma no DOM
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', fileName);

    // 6. Adiciona ao body, clica programaticamente e remove
    document.body.appendChild(link);
    link.click();

    // 7. Limpeza da memória
    link.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Falha ao realizar o download:', error);
    alert('Não foi possível baixar o arquivo.');
  }
};
